export default __webpack_public_path__ + "static/media/lslogo.8f1f5663.jpg";